import { error, misc, success } from "app/themes/colors";
import EnumDataSource from "utils/enum-data-source.util";

import { AssignedTag } from "./assigned-tag.type";
import { Clinic } from "./clinics.type";

export interface SendFaxInput {
  recipient: string;
  documents?: any;
  clinic: number;
  patient?: number;
  box_file_ids?: number | string;
  include_cover_page?: boolean;
  notes?: string;
  subject?: string;
  recipient_name?: string;
  sender_name?: string;
}

export interface FaxesQueryParams {
  recipient_name?: string;
  sender?: number;
  query?: string;
  patient?: number;
  sender_name?: string;
  assigned_tags?: number | number[];
  before_date?: string;
  after_date?: string;
  clinic?: number | number[];
  search?: string;
  deactivated?: boolean;
}

export interface FaxFilters extends FaxesQueryParams {
  limit?: number;
  offset?: number;
  ordering?: string;
}

export interface FaxResponse {
  id: number;
  created_at: string;
  sender?: {
    id: number;
    first_name: string;
    last_name: string;
    name: string;
    full_name: string;
    suffix: string;
    title: number;
    is_active: boolean;
    photo: string;
    signature: string;
  };
  clinic: Clinic;
  recipient: string;
  webhook_id: string;
  message: { faxCallerId: string; faxNumber: string };
  documents?: string[];
  box_file_ids?: string[];
  patient?: {
    id: number;
    first_name: string;
    last_name: string;
    box_folder_id?: string;
  };
  include_cover_page?: boolean;
  cover_page_id?: string | null;
  notes?: string;
  subject?: string;
  recipient_name?: string;
  sender_name?: string;
  document: string;
  status: FaxStatus | null;
  assigned_tags?: AssignedTag[];
  direction: number;
  discarded_at?: null | string;
  deactivated_at?: string | null;
  deactivated_by?: {
    id: number;
    first_name: string;
    last_name: string;
    name: string;
  } | null;
}

export enum FaxStatus {
  "Processing" = 1,
  "Cancelled",
  "Success",
  "Failed"
}

export const FAX_STATUS_COLORS: Record<FaxStatus, string> = {
  [FaxStatus.Processing]: misc.darkYellow,
  [FaxStatus.Success]: success[600],
  [FaxStatus.Failed]: error[400],
  [FaxStatus.Cancelled]: misc.warningText
};

const faxStatuses = {
  [FaxStatus.Success]: "Success",
  [FaxStatus.Processing]: "Processing",
  [FaxStatus.Failed]: "Failed",
  [FaxStatus.Cancelled]: "Cancelled"
};

export const FAXES_STATUSES = new EnumDataSource(faxStatuses);

export const FAXES_DIRECTION_OUTBOUND = 1;
export const FAXES_DIRECTION_INBOUND = 2;

export const FAXES_DIRECTIONS = new EnumDataSource({
  [FAXES_DIRECTION_INBOUND]: "Inbound",
  [FAXES_DIRECTION_OUTBOUND]: "Outbound"
});
